<template>
  <div class="container">
    <div class="clearfix">
      <div class="income">
        <span class="mr10" v-if="formData.refund_status!=1">总计<b>￥{{income}}</b></span><span class="mr10" v-if="formData.refund_status==0">手续费<b> ￥{{((income - refund_money)*6/1000).toFixed(2)}}</b></span><span class="order_sum" v-if="refund_money">已退款: <b class="money">￥{{refund_money}}</b>(手续费由微信官方退回)</span>
        <span class="ml10 mr10" v-if="formData.refund_status==0">结余费<b class="money">￥{{(income - refund_money - ((income - refund_money) * 6/1000).toFixed(2)).toFixed(2)}}</b></span>
        <div class="fr red">友情提示:订单超过10天不能申请退款！！！</div>
      </div>
      <div class="income">
        <Tooltip content="结余费 ÷ 1.03 × 3%" placement="top">
          <span class="mr10">增值税<b>￥{{zhengzhi}}</b></span>
        </Tooltip>
        <Tooltip content="增值税 × 12% 减半" placement="top">
          <span class="mr10">城建税+教育附加税+地方教育附加税<b> ￥{{thirdFee}}</b></span>
        </Tooltip>
        <Tooltip max-width="500px" content="结余费 - 增值税 - (城建税 + 教育附加税 + 地方教育附加税)" placement="top">
          <span class="mr10">实际收入<b> ￥{{realIncom}}</b></span>
        </Tooltip>
      </div>
      <Form @submit.native.prevent :model="formData" label-position="left"  class="mytable-titleBox fl mt10">
        <div class="clearfix">
          <FormItem label="标题:" class="fl mytable-title" :label-width="48">
            <Input v-model="formData.input1" style="width: 140px"></Input>
          </FormItem>
          <FormItem label="购买人昵称:" class="fl mytable-title" :label-width="94">
            <Input v-model="formData.input2" style="width: 140px"></Input>
          </FormItem>
          <FormItem v-if="isAdmin===1" label="作者昵称 :" class="fl mytable-title" :label-width="84">
            <Input v-model="formData.input3" style="width: 140px"></Input>
          </FormItem>
          <FormItem label="购买人手机号:" class="fl mytable-title" :label-width="100">
          <Input v-model="formData.phone" style="width: 140px"></Input>
        </FormItem>
          <FormItem label="订单号:" class="fl mytable-title" :label-width="64">
            <Input v-model="formData.order_no" style="width: 140px"></Input>
          </FormItem>
          <div class="fl checkReset">
            <Button type="primary" class="fl" @click="handleSearch">查询</Button>
            <Button class="fl" @click="reset">重置</Button>
          </div>

<!--          <FormItem class="fr" :label-width="84" v-model="income">-->
<!--            <div class="fr income"><span class="mr10" v-if="formData.refund_status!=1">总计<b>￥{{income}}</b></span><span class="mr10" v-if="formData.refund_status==0">手续费<b> ￥{{((income - refund_money)*6/1000).toFixed(2)}}</b></span><span class="order_sum" v-if="refund_money">已退款: <b class="money">￥{{refund_money}}</b>(手续费由微信官方退回)</span>-->
<!--            </div>-->
<!--            <br/>-->
<!--            <div class="fr income"><span class="mr10" v-if="formData.refund_status==0">结余费<b class="money">￥{{(income - refund_money - ((income - refund_money) * 6/1000).toFixed(2)).toFixed(2)}}</b></span></div>-->
<!--          </FormItem>-->

        </div>
<!--        <div class="clearfix mt24">-->
<!--          <RadioGroup v-model.trim="formData.applet_type" type="button" class="fl mr20" @on-change="statusChange">-->
<!--            <Radio label="">全部</Radio>-->
<!--          </RadioGroup>-->
<!--          <RadioGroup v-model.trim="formData.applet_type" type="button" class="fl mr20" @on-change="statusChange">-->
<!--            <Radio :label="4">内部料(人人彩)</Radio>-->
<!--          </RadioGroup>-->
<!--          <RadioGroup v-model.trim="formData.applet_type" type="button" class="fl mr20" @on-change="statusChange">-->
<!--            <Radio :label="1">内部分享(胜临智博)</Radio>-->
<!--          </RadioGroup>-->
<!--          <RadioGroup v-model.trim="formData.applet_type" type="button" class="fl mr20" @on-change="statusChange">-->
<!--            <Radio :label="3">足球财富资讯(人人彩)</Radio>-->
<!--          </RadioGroup>-->
<!--          <RadioGroup v-model.trim="formData.applet_type" type="button" class="fl mr20" @on-change="statusChange">-->
<!--            <Radio :label="2">内部说(盈宇)</Radio>-->
<!--          </RadioGroup>-->
<!--          <RadioGroup v-model.trim="formData.applet_type" type="button" class="fl mr20" @on-change="statusChange">-->
<!--            <Radio :label="7">跃查看(胜临智博)</Radio>-->
<!--          </RadioGroup>-->
<!--          <RadioGroup v-model.trim="formData.applet_type" type="button" class="fl mr20" @on-change="statusChange">-->
<!--            <Radio :label="8">欣跃读(盈宇)</Radio>-->
<!--          </RadioGroup>-->
<!--          <RadioGroup v-model.trim="formData.applet_type" type="button" class="fl mr20" @on-change="statusChange">-->
<!--            <Radio label="5-4">H5网页(人人彩)</Radio>-->
<!--            <Radio label="5-1">H5网页(胜临智博)</Radio>-->
<!--            <Radio label="5-2">H5网页(盈宇)</Radio>-->
<!--          </RadioGroup>-->
<!--        </div>-->
        <div class="clearfix mt24">
          <ul class="ul-search">
            <li :class="{'active': applet_type_arr.length==0}" @click="handleAppletChange('')">全部</li>
            <li :class="{'active': applet_type_arr.indexOf(4)!=-1}" @click="handleAppletChange(4)">内部料(人人彩)</li>
            <li :class="{'ml21':true,'active': applet_type_arr.indexOf(3)!=-1}" @click="handleAppletChange(3)">足球财富资讯(人人彩)</li>
            <li :class="{'ml21':true,'active': applet_type_arr.indexOf(9)!=-1}" @click="handleAppletChange(9)">人人查看(人人彩)</li>
            <li :class="{'active': applet_type_arr.indexOf(2)!=-1}" @click="handleAppletChange(2)">内部说(盈宇)</li>
            <li :class="{'ml21':true,'active': applet_type_arr.indexOf(8)!=-1}" @click="handleAppletChange(8)">欣跃读(盈宇)</li>
            <li :class="{'active': applet_type_arr.indexOf(1)!=-1}" @click="handleAppletChange(1)">内部分享(胜临智博)</li>
            <li :class="{'ml21':true,'active': applet_type_arr.indexOf(7)!=-1}" @click="handleAppletChange(7)">跃查看(胜临智博)</li>
            <li :class="{'active': applet_type_arr.indexOf('5_4')!=-1}" @click="handleAppletChange('5_4')">H5网页(人人彩)</li>
            <li :class="{'ml21':true,'active': applet_type_arr.indexOf('5_1')!=-1}" @click="handleAppletChange('5_1')">H5网页(胜临智博)</li>
            <li :class="{'ml21':true,'active': applet_type_arr.indexOf('5_2')!=-1}" @click="handleAppletChange('5_2')">H5网页(盈宇)</li>
          </ul>
        </div>
        <div class="mt24 clearfix">
          <FormItem label="日期范围:" :label-width="72" class="fl mytable-title">
            <DatePicker v-model="formData.date" @on-change="formData.date=$event" class="w240" type="daterange" format="yyyy-MM-dd" placeholder="开始日期 ~ 结束日期"></DatePicker>
          </FormItem>
          <RadioGroup v-model.trim="formData.refund_status" type="button" class="fl mr20" @on-change="handleSearch">
            <Radio :label="0">全部</Radio>
            <Radio :label="1">退款成功</Radio>
            <Radio :label="3">退款中</Radio>
            <Radio :label="4">退款异常</Radio>
          </RadioGroup>
<!--          <div class="fr red">友情提示:订单超过10天不能申请退款！！！</div>-->
        </div>
      </Form>
    </div>
    <Table :loading="tableLoading" class="mt24" :columns="columns1" :data="tableData"></Table>
    <Page class="mt24" :total="total" :current="page_num" show-elevator show-sizer show-total @on-page-size-change="handleSizeChange" @on-change="handlePageChange"/>
    <refundModal ref="refundModal" :id="refundId" :type="0" modalTitle="是否确认退款该笔订单" @success="getTableData" :param="activeParam"></refundModal>
  </div>

</template>

<script>
import mixins from '@/mixins/page'
import timeMixin from '@/mixins/time'
import refundModal from '@/components/refundModal.vue'
export default {
  mixins: [mixins, timeMixin],
  name: 'order_manage',
  components: {
    refundModal
  },
  data () {
    return {
      isAdmin: Number(localStorage.getItem('sa')),
      refundId: null,
      refund_money: '',
      activeParam:{},
      applet_type_arr: [],
      formItem: {
        input: '',
        select: '',
        radio: 'male',
        checkbox: [],
        switch: true,
        time: '',
        slider: [20, 50],
        textarea: ''
      },
      page_num: 1,
      page_size: 10,
      tableData: [],
      modalLoading: true,

      income: '',
      formData: {
        date: [],
        refund_status: 0
      },
      formData1: {
        date: [],
        refund_status: 0
      },
      columns1: [
        {
          title: '商户订单号',
          key: 'order_no',
          minWidth: 200
        },
        {
          title: '标题',
          key: 'title',
          minWidth: 120,
          tooltip: true
        },
        {
          title: '购买人昵称',
          key: 'username',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '手机号',
          key: 'phone',
          minWidth: 100,
          align: 'center'
        },
        {
          title: '价格',
          key: 'money',
          minWidth: 70,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              class: {
                red: true
              }
            }, params.row.money)
          }
        },
        {
          title: '手续费',
          key: 'money',
          minWidth: 80,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              class: {
                red: true
              }
            }, (params.row.money * 6 / 1000).toFixed(2))
          }
        },
        {
          title: '结余费',
          key: 'money',
          minWidth: 80,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              class: {
                red: true
              }
            }, (params.row.money - (params.row.money * 6 / 1000).toFixed(2)).toFixed(2))
          }
        },
        {
          title: '来源',
          key: 'applet_type',
          minWidth: 80,
          render: (h, params) => {
            if (params.row.applet_type === 1) {
              return h('span', {

              }, '内部分享')
            } else if (params.row.applet_type === 2) {
              return h('span', {

              }, '内部说')
            } else if (params.row.applet_type === 3) {
              return h('span', {

              }, '足球财富资讯')
            } else if (params.row.applet_type === 4) {
              return h('span', {
              }, '内部料')
            } else if (params.row.applet_type === 5) {
              return h('span', {
              }, 'H5网页')
            } else if (params.row.applet_type === 6) {
              return h('span', {
              }, 'H5网页')
            } else if (params.row.applet_type === 7) {
              return h('span', {
              }, '跃查看')
            } else if (params.row.applet_type === 8) {
              return h('span', {
              }, '欣跃读')
            }else if (params.row.applet_type === 9) {
              return h('span', {
              }, '人人查看')
            } else {
              return h('span', {
              }, '未知')
            }
          }
        },
        {
          title: '商户',
          minWidth: 70,
          render: (h, params) => {
            if (params.row.type === 1) {
              return h('span', {}, '胜临智博')
            } else if (params.row.type === 2) {
              return h('span', {}, '盈宇')
            } else if (params.row.type === 4) {
              return h('span', {}, '人人彩')
            } else {
              if (params.row.applet_type === 4 || params.row.applet_type === 3) { // 内部料 足球财富
                return h('span', {}, '人人彩')
              } else if (params.row.applet_type === 1) { // 内部分享
                return h('span', {}, '胜临智博')
              } else if (params.row.applet_type === 2) { // 内部说
                return h('span', {}, '盈宇')
              } else if (params.row.applet_type === 7) { // 跃查看
                return h('span', {}, '胜临智博')
              } else if (params.row.applet_type === 8) { // 欣跃读
                return h('span', {}, '盈宇')
              }else if (params.row.applet_type === 9) { // 人人查看
                return h('span', {}, '人人彩')
              } else {
                return h('span', {}, '未知')
              }
            }
          }
        },
        // {
        //   title: '支付途径',
        //   minWidth: 80,
        //   render: (h, params) => {
        //     if (params.row.order_type === 0) {
        //       return h('span', {}, '微信')
        //     } else if (params.row.order_type === 1) {
        //       return h('span', {}, '支付宝')
        //     }
        //   }
        // },
        {
          title: '购买时间',
          minWidth: 150,
          key: 'create_time'
        },
        {
          title: '作者昵称',
          minWidth: 150,
          key: 'post_username'
        },
        // {
        //   title: '状态',
        //   minWidth: 60,
        //   key: 'post_username',
        //   render(h, params){
        //     return h('span',{class:{red:true}},'已退款')
        //   }
        // },
        {
          title: '退款时间',
          key: 'refund_time',
          minWidth: 150
        },
        {
          title: '退款操作',
          width: 110,
          key: 'post_username',
          render: (h, params) => {
            let returnHtml = ''
            switch (params.row.refund_status) {
              case 0:
                if (!this.isRefundExpire(params.row.create_time)) {
                  returnHtml = h('span', {
                    class: {
                      btn_refund: true
                    },
                    on: {
                      click: () => this.handleRefund(params)
                    }
                  }, '申请退款')
                }
                break
              case 1:
                returnHtml = h('span', { class: { gray: true } }, '退款成功')
                break
              case 3:
                returnHtml = h('span', { class: { yellow: true } }, '退款中')
                break
              case 4:
                returnHtml = h('span', { class: { red: true } }, '退款异常')
                break
            }
            return returnHtml
          }
        }
      ]
    }
  },
  computed:{
    // 增值税
    zhengzhi(){
      // 增值税=收入÷1.03×3%
      let overMonery = (this.income - this.refund_money - ((this.income - this.refund_money) * 6/1000).toFixed(2)).toFixed(2);
     return (overMonery / 1.03 * 0.03).toFixed(2)
    },
    // 城建税+教育附加+地方教育附加税
    thirdFee(){
      // 城建税+教育附加+地方教育附加税=增值税×12% 减半
      let overMonery = (this.income - this.refund_money - ((this.income - this.refund_money) * 6/1000).toFixed(2)).toFixed(2);
      let zhengzhi = (overMonery / 1.03 * 0.03).toFixed(2)
      return (zhengzhi * 0.12 / 2).toFixed(2)
    },
    // 实际收入
    realIncom(){
      let overMonery = (this.income - this.refund_money - ((this.income - this.refund_money) * 6/1000).toFixed(2)).toFixed(2);
      let zhengzhi = (overMonery / 1.03 * 0.03).toFixed(2)
      let thirdFee = (zhengzhi * 0.12 / 2).toFixed(2)
      return (overMonery - zhengzhi - thirdFee).toFixed(2)
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    // 获取表格数据
    handleAppletChange(str){
      if(!str){
        this.applet_type_arr = []
      }else{
        let index = this.applet_type_arr.indexOf(str);
        if(index!=-1){
          this.applet_type_arr.splice(index,1);
        }else{
          this.applet_type_arr.push(str)
        }
      }
      this.handleSearch()
    },
    getTableData () {
      this.tableLoading = true
      let start_time = this.formData.date[0] ? this.formData.date[0] + ' 00:00:00' : ''
      let end_time = this.formData.date[1] ? this.formData.date[1] + ' 24:00:00' : ''
      // if(this.formData.applet_type && this.formData.applet_type.test(/-/g)){
      //   this.formData.type = this.formData.applet_type.split('-')[1];
      // }
      let param = {
        refund_status: this.formData.refund_status,
        page_num: this.page_num,
        page_size: this.page_size,
        start_time,
        end_time,
        // applet_type: this.formData.applet_type ? this.formData.applet_type.toString().split('-')[0] - 0 : '',
        applet_type: this.applet_type_arr.join(','),
        username: this.formData.input2, // 购买人昵称
        post_username: this.formData.input3, // 作者昵称
        phone: this.formData.phone, //购买人手机号
        order_no: this.formData.order_no,
        title: this.formData.input1,
        // type: this.formData.applet_type ? this.formData.applet_type.toString().split('-')[1] - 0 : '',
        order_type: this.formData.order_type
      }
      if (param.refund_status == 0) {
        delete param.refund_status
      }
      this.$api.orderList(param).then(res => {
        console.log('res',res)
        if (res.code === 0) {
          this.tableData = res.data.list
          // 收入
          this.income = res.data.ext.sum_money
          this.refund_money = res.data.ext.refund_money
          this.total = res.data.total_row
        } else {
          this.$Message.error(res.msg)
        }
        this.tableLoading = false
      })
    },
    // 查询
    handleSearch () {
      // 有数据且搜索框一个不为空的时候执行搜索
      this.page_num = 1
      this.getTableData()
    },
    // 重置
    reset () {
      this.formData = Object.assign({}, this.formData1)
      this.applet_type_arr = []
      this.handleSearch()
    },
    statusChange () {
      this.handleSearch()
    },
    // 退款
    handleRefund (param) {
      this.$refs.refundModal.modalVisibile = true
      this.refundId = param.row.id
      this.activeParam = param.row
      console.log('row',param.row)
    }
  }
}
</script>

<style scoped lang="less">
  .ul-search{
    li{
      display: inline-block;
      border-radius: 4px;
      border: 1px solid #dcdee2;
      margin-right: 20px;
      line-height: 30px;
      padding: 0 15px;
      cursor: pointer;
      &.active{
        border-color: #2d8cf0;
        color: #2d8cf0;
      }
    }
  }
  .ml21{
    margin-left: -21px;
  }
  /deep/ .ivu-form-item{
    margin-bottom: 0;
  }
  .mytable-titleBox{
    width: 100%;
  }
  .checkReset:first-child {
    margin-right: 8px;
  }

  .ivu-modal-footer{
    border-top: none !important;
  }
  .shadowLine{
    width: 660px;
    height: 1px;
    background: #E9E9E9;
    margin: 24px 0;
  }
  .wechartBox{
    width: 282px;
    border: 1px solid #DCE1E6;
    border-radius: 4px;
    line-height: 32px;
    padding-left: 12px;
    span{
      width: 74px;
      text-align: center;
      border-left:  1px solid #DCE1E6;
      cursor: pointer;
    }
  }

  /deep/ .ivu-upload-drag{
    border: none;
    background: transparent;
  }
  /deep/ .textarea.ivu-input{
    min-height: 88px;
    height: 88px;
  }
  .playFont{
    color:#8A9299;
  }
  .boldTitle{
    color:#000;
    font-weight:bold;
    font-size: 14px;
  }
  .graybg{
    width: 724px;
    height: 12px;
    background: #F0F3F5;
    position: relative;
    left: -32px;
    margin-bottom: 24px;
    margin-top: 8px;
  }
  .shadowTitleClick span{
    cursor: pointer;
  }
  .income b{
    color: #FF5579;
    /*font-weight: bold;*/

  }
  .income{
    line-height: 32px;
    font-size: 16px;
  }
  .mytable-title{
    margin-right: 10px;
  }
  @media screen and (max-width: 1400px) and (min-width: 1300px) {
    .mytable-title{
      margin-right: 10px;
    }
    .addAuthor{

    }
  }
</style>
